export class GcpDiskSnapshotProperties {
    'diskId';
    'diskName';
    'deviceName';
    'diskType';
    'diskSizeBytes';
    'tags';
    'iops';
    'throughput';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "diskId",
            "baseName": "diskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskName",
            "baseName": "diskName",
            "type": "string",
            "format": ""
        },
        {
            "name": "deviceName",
            "baseName": "deviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskType",
            "baseName": "diskType",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskSizeBytes",
            "baseName": "diskSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "iops",
            "baseName": "iops",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "throughput",
            "baseName": "throughput",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GcpDiskSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
